import React from 'react';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="cta" id="contacto">
      <div className="cta__bg" />
      <div className="cta__content reveal">
        <div className="section-label">¿Listo para empezar?</div>
        <h2 className="cta__title">
          HAGAMOS ALGO<br /><span className="orange">INCREÍBLE</span>
        </h2>
        <p className="cta__sub">
          Cuéntanos tu idea y juntos la convertiremos en una experiencia digital que impacte.
        </p>
        <div className="cta__form">
          <input
            type="email"
            className="cta__input"
            placeholder="tu@email.com"
            onFocus={() => navigate('/contacto')}
            readOnly
            aria-label="Ingresa tu email para iniciar contacto"
          />
          <button 
            className="btn-primary" 
            onClick={() => navigate('/contacto')}
            aria-label="Enviar solicitud de contacto"
          >
            Enviar
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
